import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setCargoConsultaCurriculos: ['cargo'],
    limpaFiltroConsultaCurriculos: [],
    receberFiltroConsultaCurriculos: ['filtroRecebido'],
    setStatusConsultaCurriculos: ['status'],
})

const INITIAL_STATE = {
    cargo: '',
    status: { label: '', value: '' },
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_CARGO_CONSULTA_CURRICULOS]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_CURRICULOS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CURRICULOS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CURRICULOS]: setStatus,
})
